import React from 'react';

export default function Loader(props) {
  let { style } = props;

  return (
    <div className='loader-round' style={style}/>
  )
}